"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeparatedByThousands = void 0;
const getSeparatedByThousands = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
exports.getSeparatedByThousands = getSeparatedByThousands;
//# sourceMappingURL=getSeparatedByThousands.js.map